import React from 'react'
import { Container } from 'react-bootstrap'
import { Parallax, Background } from 'react-parallax';
import GrowthChart from '../components/growth-chart'
import Image from '../components/image'

import backgroundImage from '../images/connor-group-central-support-office.jpg'


export default (props) => {
  return (
    <section className="section section--dark section--shadowed" style={{"--section-padding-bottom": "0" }}>
      <Parallax strength={600}>
        <Background className="custom-bg">
          <img src={backgroundImage} style={{width: "100%"}} />
        </Background>
        <Container>
          <div class="section__content">
            <div>
              <h2 className="kh-h2 kh-h2--xl">{props.headline}</h2>
              <div className="photo-quote-cluster-3">
                <Image {...props.quote.photo.localFile.childImageSharp.fluid} alt={props.quote.photo.altText} className="photo-quote-cluster-3__image" />
                <blockquote className="photo-quote-cluster-3__blockquote kh-blockquote">
                  <p>
                    {props.quote.content}
                  </p>
                  <footer className="kh-blockquote__footer">
                    <span className="kh-blockquote__name">- {props.quote.citation}</span>
                    <span className="kh-blockquote__position">{props.quote.subtext}</span>
                  </footer>
                </blockquote>
              </div>
            </div>
            <GrowthChart />
          </div>
        </Container>
      </Parallax>
    </section>
  )
}